/* eslint-disable import/prefer-default-export */

export const MEDIA_TOKEN = "194b8db0098a5db1d8f7464b430c42ff";

// REPEATS

export const DAILY_REPEAT = "daily";
export const WEEKLY_REPEAT = "weekly";
export const NO_REPEAT = "no_repeat";
export const NO_REPEAT_SEQUENCE = "no_repeat_sequence";

// URLS

export const GET_SCHEDULE_URL = "linearChannelSchedules/";

// Changes the default sections per one hour
export const DEFAULT_SECTIONS_PER_HOUR = 4;

export const DEFAULT_MEDIA_DESCRIPTION = "No Description.";

// Context Menu

export const SCHEDULER_CONTEXT_MENU_ID = "scheduler_context_menu";

export const ADD = "add";
export const ADD_LIVE_SLOT = "addLiveSlot";
export const ADD_AD_SLOT = "addAdSlot";
export const EDIT = "edit";
export const DELETE = "delete";
export const DELETE_ALL_SELECTED = "deleteAllSelected";
export const PREVIEW = "preview";
export const COLLAPSE = "collapse";
export const COLLAPSE_ALL = "collapseAll";

// View Modes

export const viewModes = {
  HOURLY: "hourly",
  DAILY: "daily",
  WEEKLY: "weekly"
};

export const BASE_PIXELS = 13.16 / 592;

// 0 - 15 min intervals; 5 - 5 min intervals, 10 - 1 min
export const SLIDER_MAX_ZOOM_LEVEL = 5;

export const DAYS_OF_THE_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

export const SECS_IN_DAY = 86400;

// Calendar action types

export const SET_EVENTS = "SET_EVENTS";
export const SET_EVENTS_INITIAL = "SET_EVENTS_INITIAL";
export const UNDO = "UNDO";
export const CLEAR_SELECTED_EVENTS = "CLEAR_SELECTED_EVENTS";
export const UPDATE_SELECTED_EVENTS = "UPDATE_SELECTED_EVENTS";
